import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


import Dashboard from './dashboard/dashboard';
import LoginPage from './dashboard/components/login';
import ProtectedRoute from './components/protectedRoutes';
import NewsDisplay from './dashboard/components/newsDisplay';
import UpdateNewsPage from './dashboard/components/UpdateNewsPage';
import NewsLayout from './Home/news';
import TermsOfService from './Home/terms';
import PrivacyPolicy from './Home/privacy';
import Contact from './Home/contact';
import ArticleEditor from './test';
import Review from './Home/detailed-review';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      cacheTime: 15 * 60 * 1000,
      retry: 1,
      retryDelay: 1000, 
    },
  },
});



function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="">
          <Routes>
            <Route 
              path="/Dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* <Route path="/" element={<Navigate to="/الدارالعراقية" replace />} /> */}
            <Route path="/auth" element={<LoginPage />} />
            {/* <Route path='update' element={<UpdateNewsPage />} /> */}
            <Route path="/news/:id" element={<NewsDisplay />} />
            <Route path='/' element={ <NewsLayout />}/>
              
            
              <Route path='/editor' element={<ArticleEditor />}  />
              <Route path='/Terms' element={<TermsOfService />}  />
              <Route path='/privacy' element={<PrivacyPolicy />}  />
              <Route path='/contact' element ={<Contact />} />
              <Route path="detailed-review" element={<Review/>} />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;